(function () {
    'use strict';

    var app = angular.module('app');

    // Collect the routes
    app.constant('routes', getRoutes());

    // Configure the routes and route resolvers
    app.config(['$routeProvider', 'routes', routeConfigurator]);
    function routeConfigurator($routeProvider, routes) {

        routes.forEach(function (r) {
            $routeProvider.when(r.url, r.config);
        });
        $routeProvider.otherwise({ redirectTo: '/' });
    }

    // Define the routes 
    function getRoutes() {
        return [
            {
                url: '/',
                config: {
                    title: 'dashboard',
                    templateUrl: '/app/dashboard/dashboard_USER.html?version=127'
                }
            },
            {
                url: '/dashboard_Super',
                config: {
                    title: 'dashboard',
                    templateUrl: '/app/dashboard/dashboard_Super.html?version=127'
                }
            },
            {
                url: '/dashboard_GEST',
                config: {
                    title: 'dashboard',
                    templateUrl: '/app/dashboard/dashboard_GEST.html?version=127'
                }
            },
            {
                url: '/dashboard_CPI',
                config: {
                    title: 'dashboard',
                    templateUrl: '/app/dashboard/dashboard_CPI.html?version=127'
                }
            },
            {
                url: '/dashboard_APL',
                config: {
                    title: 'dashboard',
                    templateUrl: '/app/dashboard/dashboard_APL.html?version=127'
                }
            },
            {
                url: '/dashboard_GUEST',
                config: {
                    title: 'dashboard',
                    templateUrl: '/app/dashboard/dashboard_GUEST.html?version=127'
                }
            },
            {
                url: '/dashboard_GUESTFORM',
                config: {
                    title: 'dashboard',
                    templateUrl: '/app/dashboard/dashboard_GUESTFORM.html?version=127'
                }
            },
            {
                url: '/dashboard_UMC',
                config: {
                    title: 'dashboard',
                    templateUrl: '/app/dashboard/dashboard_UMC.html?version=127'
                }
            },
            {
                url: '/dashboard_FAM',
                config: {
                    title: 'dashboard',
                    templateUrl: '/app/dashboard/dashboard_FAM.html?version=127'
                }
            },
            //DESTINATARIO DIRETTO
            {
                url: '/destinatariodiretto',
                config: {
                    title: 'destinataridiretti',
                    templateUrl: '/app/RUBRICA/destinatariodiretto/destinataridiretti.html?version=127'
                }
            }, {
                url: '/destinatariodiretto/:DestinatarioDirettoId',
                config: {
                    title: 'destinatariodirettoDetail',
                    templateUrl: '/app/RUBRICA/destinatariodiretto/destinataridiretti.html?version=127'
                }
            },
            //DESTINATARIO INDENNITA
            {
                url: '/destinatarioIndennita',
                config: {
                    title: 'destinatariIndennita',
                    templateUrl: '/app/RUBRICA/destinatarioIndennita/destinatariIndennita.html?version=127'
                }
            }, {
                url: '/destinatarioIndennita/:DestinatarioIndennitaId',
                config: {
                    title: 'destinatariodirettoDetail',
                    templateUrl: '/app/RUBRICA/destinatarioIndennita/destinatariIndennita.html?version=127'
                }
            },
            //DESTINATARIO INDENNITA INPS
            {
                url: '/destinatarioIndennitaINPS',
                config: {
                    title: 'destinatariIndennitaINPS',
                    templateUrl: '/app/RUBRICA/destinatarioIndennitaINPS/destinatariIndennitaINPS.html?version=127'
                }
            }, {
                url: '/destinatarioIndennitaINPS/:DestinatarioIndennitaINPSId',
                config: {
                    title: 'destinatariodirettoINPSDetail',
                    templateUrl: '/app/RUBRICA/destinatarioIndennitaINPS/destinatariIndennitaINPS.html?version=127'
                }
            },
            //DESTINATARIO INDENNITA INPS EXPORT
            {
                url: '/destinatarioIndennitaINPSExport',
                config: {
                    title: 'destinatariIndennitaINPSExport',
                    templateUrl: '/app/RUBRICA/destinatarioIndennitaINPSExport/destinatariIndennitaINPSExport.html?version=127'
                }
            }, {
                url: '/destinatarioIndennitaINPSExport/:DestinatarioIndennitaINPSExportId',
                config: {
                    title: 'destinatariodirettoINPSExportDetail',
                    templateUrl: '/app/RUBRICA/destinatarioIndennitaINPSExport/destinatariIndennitaINPSExport.html?version=127'
                }
            },
            //SOGGETTO COLLEGATO
            {
                url: '/soggettoCollegato',
                config: {
                    title: 'soggettoCollegato',
                    templateUrl: '/app/RUBRICA/soggettoCollegato/soggettiCollegati.html?version=127'
                }
            }, {
                url: '/soggettoCollegato/:soggCollegatoId',
                config: {
                    title: 'soggettoCollegatoDetail',
                    templateUrl: '/app/RUBRICA/soggettoCollegato/soggettiCollegati.html?version=127'
                }
            },
            //TABELLA UCS
            {
                url: '/percorsiLEPUCS',
                config: {
                    title: 'percorsiLEPUCS',
                    templateUrl: '/app/RUBRICA/percorsiLEPUCS/percorsiLEPUCS.html?version=127'
                }
            }, {
                url: '/percorsiLEPUCS/:PLUCSId',
                config: {
                    title: 'percorsiLEPUCSDetail',
                    templateUrl: '/app/RUBRICA/percorsiLEPUCS/percorsiLEPUCS.html?version=127'
                }
            },
            //TABELLA ECONOMIE
            {
                url: '/percorsiLEPEconomie',
                config: {
                    title: 'percorsiLEPEconomie',
                    templateUrl: '/app/RUBRICA/percorsiLEPEconomie/percorsiLEPEconomie.html?version=127'
                }
            }, {
                url: '/percorsiLEPEconomie/:PLUCSId',
                config: {
                    title: 'percorsiLEPEconomieDetail',
                    templateUrl: '/app/RUBRICA/percorsiLEPEconomie/percorsiLEPEconomie.html?version=127'
                }
            },
            //ISSUE-LOG
            {
                url: '/issueLog',
                config: {
                    title: 'issueLog',
                    templateUrl: '/app/STRUMENTI/issueLog/issuesLog.html?version=127'
                }
            }, {
                url: '/issueLog/:IssueLogId',
                config: {
                    title: 'issueLogDetail',
                    templateUrl: '/app/STRUMENTI/issueLog/issuesLog.html?version=127'
                }
            },
            //MY-LOG
            {
                url: '/myLog',
                config: {
                    title: 'myLog',
                    templateUrl: '/app/STRUMENTI/myLog/myLogs.html?version=127'
                }
            }, {
                url: '/myLog/:MyLogId',
                config: {
                    title: 'myLogDetail',
                    templateUrl: '/app/STRUMENTI/myLog/myLogs.html?version=127'
                }
            },
            //PARAMS
            {
                url: '/params',
                config: {
                    title: 'params',
                    templateUrl: '/app/STRUMENTI/params/params.html?version=127'
                }
            }, {
                url: '/params/:ParamsId',
                config: {
                    title: 'paramsDetail',
                    templateUrl: '/app/STRUMENTI/params/params.html?version=127'
                }
            },
            //NOTIFICATION
            {
                url: '/notifications',
                config: {
                    title: 'notifications',
                    templateUrl: '/app/STRUMENTI/notification/notifications.html?version=127'
                }
            }, {
                url: '/notifications/:NotificationId',
                config: {
                    title: 'notificationDetail',
                    templateUrl: '/app/STRUMENTI/notification/notifications.html?version=127'
                }
            },
            //DOWNLOAD
            {
                url: '/downloads',
                config: {
                    title: 'downloads',
                    templateUrl: '/app/STRUMENTI/download/downloads.html?version=127'
                }
            }, {
                url: '/downloads/:DownloadId',
                config: {
                    title: 'downloadDetail',
                    templateUrl: '/app/STRUMENTI/download/downloads.html?version=127'
                }
            },
            //VIDEOGUIDE
            {
                url: '/videoGuida',
                config: {
                    title: 'videoGuida',
                    templateUrl: '/app/STRUMENTI/videoGuida/videoGuide.html?version=127'
                }
            },
            {
                url: '/videoGuida/:VideoGuidaId',
                config: {
                    title: 'videoguideDetail',
                    templateUrl: '/app/STRUMENTI/videoGuida/videoGuide.html?version=127'
                }
            },
            //CORSO
            {
                url: '/corso',
                config: {
                    title: 'corsi',
                    templateUrl: '/app/FORMAZIONE/corso/corsi.html?version=127'
                }
            },
            {
                url: '/corso/:CorsoId',
                config: {
                    title: 'corso',
                    templateUrl: '/app/FORMAZIONE/corso/corsi.html?version=127'
                }
            },
            //ORIENTAMENTO
            {
                url: '/orientamento',
                config: {
                    title: 'orientamenti',
                    templateUrl: '/app/MISURA1C/orientamento/orientamenti.html?version=127'
                }
            },

            {
                url: '/orientamento/:OrientamentoId',
                config: {
                    title: 'orientamento',
                    templateUrl: '/app/MISURA1C/orientamento/orientamenti.html?version=127'
                }
            },
            //ORIENTAMENTO-DEST
            {
                url: '/orientamentoDest',
                config: {
                    title: 'orientamentiDest',
                    templateUrl: '/app/MISURA1C/orientamentoDest/orientamentoDest.html?version=127'
                }
            },
            //ORIENTAMENTO RIMBORSO
            {
                url: '/oriRimborso',
                config: {
                    title: 'oriRimborsi',
                    templateUrl: '/app/MISURA1C/oriRimborso/oriRimborsi.html?version=127'
                }
            },
            {
                url: '/oriRimborso/:OriRimborsoId',
                config: {
                    title: 'oriRimborso',
                    templateUrl: '/app/MISURA1C/oriRimborso/oriRimborsi.html?version=127'
                }
            },
            //AUTOIMPIEGO
            {
                url: '/aim',
                config: {
                    title: 'autoimpiego',
                    templateUrl: '/app/MISURA7/aim/aim.html?version=127'
                }
            },
            {
                url: '/aim/:AimId',
                config: {
                    title: 'autoimpiego',
                    templateUrl: '/app/MISURA7/aim/aim.html?version=127'
                }
            },
            //AUTOIMPIEGO SERVIZIO
            {
                url: '/aimServizio',
                config: {
                    title: 'autoimpiegoServizio',
                    templateUrl: '/app/MISURA7/aimServizio/aimServizi.html?version=127'
                }
            },
            {
                url: '/aimServizio/:AimServizioId',
                config: {
                    title: 'autoimpiegoServizio',
                    templateUrl: '/app/MISURA7/aimServizio/aimServizi.html?version=127'
                }
            },
            //AUTOIMPIEGO RIMBORSO
            {
                url: '/aimRmb',
                config: {
                    title: 'autoimpiegoRmb',
                    templateUrl: '/app/MISURA7/aimRmb/aimRmb.html?version=127'
                }
            },
            {
                url: '/aimRmb/:AimRmbId',
                config: {
                    title: 'autoimpiegoRmb',
                    templateUrl: '/app/MISURA7/aimRmb/aimRmb.html?version=127'
                }
            },
            //AUTOIMPIEGO SPETTANZE
            {
                url: '/aimSpettanza',
                config: {
                    title: 'aimSpettanze',
                    templateUrl: '/app/MISURA7/aimSpettanza/aimSpettanze.html?version=127'
                }
            },
            {
                url: '/aimSpettanza/:AimSpettanzaId',
                config: {
                    title: 'aimSpettanze',
                    templateUrl: '/app/MISURA7/aimSpettanza/aimSpettanze.html?version=127'
                }
            },
            //ASSUNZIONE E FORMAZIONE - MISURA 2C
            {
                url: '/assForm',
                config: {
                    title: 'assForm',
                    templateUrl: '/app/MISURA2C/assForm/assForm.html?version=127'
                }
            },
            {
                url: '/assForm/:AssFormId',
                config: {
                    title: 'assForm',
                    templateUrl: '/app/MISURA2C/assForm/assForm.html?version=127'
                }
            },
            //REG-PRESENZE - MISURA 2C
            {
                url: '/regPresenze2C',
                config: {
                    title: 'regPresenze2C',
                    templateUrl: '/app/MISURA2C/regPresenze2C/regPresenze2C.html?version=127'
                }
            }, {
                url: '/regPresenze2C/:RegPresenza2CId',
                config: {
                    title: 'regPresenze2CDetail',
                    templateUrl: '/app/MISURA2C/regPresenze2C/regPresenze2C.html?version=127'
                }
            },
            //ASSUNZIONE E FORMAZIONE RIMBORSO - MISURA 2C
            {
                url: '/assFormRmb',
                config: {
                    title: 'assFormRmb',
                    templateUrl: '/app/MISURA2C/assFormRmb/assFormRmb.html?version=127'
                }
            },
            {
                url: '/assFormRmb/:AssFormRmb',
                config: {
                    title: 'assFormRmb',
                    templateUrl: '/app/MISURA2C/assFormRmb/assFormRmb.html?version=127'
                }
            },
            //SAP
            {
                url: '/sap',
                config: {
                    title: 'sap',
                    templateUrl: '/app/RUBRICA/SAP/sap.html?version=127'
                }
            },
            {
                url: '/sap/:SapId',
                config: {
                    title: 'sapDetail',
                    templateUrl: '/app/RUBRICA/SAP/sap.html?version=127'
                }
            },
            //PAGAMENTO
            {
                url: '/pagamento',
                config: {
                    title: 'pagamenti',
                    templateUrl: '/app/STRUMENTI/pagamento/pagamenti.html?version=127'
                }
            },
            {
                url: '/pagamento/:PagamentoId',
                config: {
                    title: 'pagamento',
                    templateUrl: '/app/STRUMENTI/pagamento/pagamenti.html?version=127'
                }
            },
            //Diario di bordo
            {
                url: '/diariodibordo',
                config: {
                    title: 'diariodibordo',
                    templateUrl: '/app/STRUMENTI/diariodibordo/diari.html?version=127'
                }
            },
            //HTMLTEMPLATE
            {
                url: '/htmlTemplate',
                config: {
                    title: 'htmlTemplates',
                    templateUrl: '/app/STRUMENTI/htmlTemplate/htmlTemplates.html?version=127'
                }
            },
            {
                url: '/htmlTemplate/:HTMLTemplateId',
                config: {
                    title: 'htmlTemplates',
                    templateUrl: '/app/STRUMENTI/htmlTemplate/htmlTemplates.html?version=127'
                }
            },
            //SEDE
            {
                url: '/sede',
                config: {
                    title: 'sedi',
                    templateUrl: '/app/sede/sedi.html?version=127'
                }
            }, {
                url: '/sede/:SedeId',
                config: {
                    title: 'sedeDetail',
                    templateUrl: '/app/sede/sedi.html?version=127'
                }
            },
            //ISTITUTO
            {
                url: '/istituto',
                config: {
                    title: 'istituti',
                    templateUrl: '/app/FORMAZIONE/istituto/istituti.html?version=127'
                }
            }, {
                url: '/istituto/:IstitutoId',
                config: {
                    title: 'istitutoDetail',
                    templateUrl: '/app/FORMAZIONE/istituto/istituti.html?version=127'
                }
            },
            //CLASSE
            {
                url: '/classe',
                config: {
                    title: 'classi',
                    templateUrl: '/app/FORMAZIONE/classe/classi.html?version=127'
                }
            },
            {
                url: '/classe/:ClasseId',
                config: {
                    title: 'classeDetail',
                    templateUrl: '/app/FORMAZIONE/classe/classi.html?version=127'
                }
            },
            //CLASSE STUDENTE
            {
                url: '/classeStudente',
                config: {
                    title: 'classeStudenti',
                    templateUrl: '/app/FORMAZIONE/classeStudente/classeStudenti.html?version=127'
                }
            },
            {
                url: '/classeStudente/:ClasseStudenteId',
                config: {
                    title: 'classeStudenteDetail',
                    templateUrl: '/app/FORMAZIONE/classeStudente/classeStudenti.html?version=127'
                }
            },
            //CLASSE LEZIONEGG
            {
                url: '/classeLezioneGG',
                config: {
                    title: 'classiLezioniGG',
                    templateUrl: '/app/classeLezioneGG/classiLezioniGG.html?version=127'
                }
            },
            //DOCENZA
            {
                url: '/docenza',
                config: {
                    title: 'docenza',
                    templateUrl: '/app/FORMAZIONE/docenza/docenze.html?version=127'
                }
            }, {
                url: '/docenza/:DocenzaId',
                config: {
                    title: 'docenzaDetail',
                    templateUrl: '/app/FORMAZIONE/docenza/docenzaDetail.html?version=127'
                }
            },
            //TICKET
            {
                url: '/ticket',
                config: {
                    title: 'ticket',
                    templateUrl: '/app/STRUMENTI/ticket/ticket.html?version=127'
                }
            },
            {
                url: '/ticket/:TicketId',
                config: {
                    title: 'ticketDetail',
                    templateUrl: '/app/STRUMENTI/ticket/ticket.html?version=127'
                }
            },
            //INCARICO
            {
                url: '/incarico',
                config: {
                    title: 'incarichi',
                    templateUrl: '/app/FORMAZIONE/incarico/incarichi.html?version=127'
                }
            }, {
                url: '/incarico/:IncaricoId',
                config: {
                    title: 'incaricoDetail',
                    templateUrl: '/app/FORMAZIONE/incarico/incaricoDetail.html?version=127'
                }
            },
            //LEZIONE
            {
                url: '/lezione',
                config: {
                    title: 'lezioni',
                    templateUrl: '/app/FORMAZIONE/lezione/lezioni.html?version=127'
                }
            }, {
                url: '/lezione/:LezioneId',
                config: {
                    title: 'lezioneDetail',
                    templateUrl: '/app/FORMAZIONE/lezione/lezioneDetail.html?version=127'
                }
            },
            //LEZIONE CPI
            {
                url: '/lezionecpi',
                config: {
                    title: 'lezionicpi',
                    templateUrl: '/app/FORMAZIONE/lezioneCpi/lezioniCpi.html?version=127'
                }
            }, {
                url: '/lezionecpi/:LezioneId',
                config: {
                    title: 'lezionecpiDetail',
                    templateUrl: '/app/FORMAZIONE/lezionecpi/lezioneCpiDetail.html?version=127'
                }
            },
            //REGISTRO ATTIVITA
            {
                url: '/regAttivita',
                config: {
                    title: 'regAttivita',
                    templateUrl: '/app/STRUMENTI/regAttivita/regAttivita.html?version=127'
                }
            }, {
                url: '/regAttivita/:regAttivitaId',
                config: {
                    title: 'regAttivitaDetail',
                    templateUrl: '/app/STRUMENTI/regAttivita/regAttivitaDetail.html?version=127'
                }
            },
            //REGISTRO ATTIVITA ANOMALIA
            {
                url: '/regAttAnomalia',
                config: {
                    title: 'regAttAnomalia',
                    templateUrl: '/app/STRUMENTI/regAttAnomalia/regAttAnomalie.html?version=127'
                }
            }, {
                url: '/regAttAnomalia/:regAttivitaId',
                config: {
                    title: 'regAttivitaDetail',
                    templateUrl: '/app/STRUMENTI/regAttAnomalia/regAttAnomalie.html?version=127'
                }
            },
            //NEWSLETTER
            {
                url: '/newsletter',
                config: {
                    title: 'newsletter',
                    templateUrl: '/app/STRUMENTI/newsletter/newsletter.html?version=127'
                }
            },
            //SIGNATURE
            {
                url: '/signature',
                config: {
                    title: 'signature',
                    templateUrl: '/app/STRUMENTI/signature/signature.html?version=127'
                }
            },
            //AZIENDA
            {
                url: '/azienda',
                config: {
                    title: 'aziende',
                    templateUrl: '/app/RUBRICA/azienda/aziende.html?version=127'
                }
            },
            {
                url: '/azienda/:AziendaId',
                config: {
                    title: 'aziendaDetail',
                    templateUrl: '/app/RUBRICA/azienda/aziende.html?version=127'
                }
            },
            //AZIENDASEDE
            {
                url: '/aziendaSede',
                config: {
                    title: 'aziendaSedi',
                    templateUrl: '/app/RUBRICA/aziendaSede/aziendaSedi.html?version=127'
                }
            },
            {
                url: '/aziendaSede/:AziendaSedeId',
                config: {
                    title: 'aziendaSedeDetail',
                    templateUrl: '/app/RUBRICA/aziendaSede/aziendaSedi.html?version=127'
                }
            },
            //TIROCINIO
            {
                url: '/tirocinio',
                config: {
                    title: 'tirocini',
                    templateUrl: '/app/MISURA5/tirocinio/tirocini.html?version=127'
                }
            }, {
                url: '/tirocinio/:TirocinioId',
                config: {
                    title: 'tirocinioDetail',
                    templateUrl: '/app/MISURA5/tirocinio/tirocini.html?version=127'
                }
            },
            //REG-PRESENZE
            {
                url: '/regPresenze',
                config: {
                    title: 'regPresenze',
                    templateUrl: '/app/MISURA5/regPresenze/regPresenze.html?version=127'
                }
            }, {
                url: '/regPresenze/:RegPresenzaId',
                config: {
                    title: 'regPresenzeDetail',
                    templateUrl: '/app/MISURA5/regPresenze/regPresenze.html?version=127'
                }
            },
            //TIROCINIO LOGS
            {
                url: '/tirLog',
                config: {
                    title: 'tirLog',
                    templateUrl: '/app/STRUMENTI/tirLog/tirLogs.html?version=127'
                }
            }, {
                url: '/tirLog/:TirLogId',
                config: {
                    title: 'tirocinioDetail',
                    templateUrl: '/app/STRUMENTI/tirLog/tirLogs.html?version=127'
                }
            },
            //OUTCOME
            {
                url: '/Outcome',
                config: {
                    title: 'Outcome',
                    templateUrl: '/app/RENDICONTAZIONE/OUTCOME/outcomes.html?version=127'
                }
            }, {
                url: '/Outcome/:OutcomeId',
                config: {
                    title: 'OutcomeDetail',
                    templateUrl: '/app/RENDICONTAZIONE/OUTCOME/outcomes.html?version=127'
                }
            },
            //COMMISSIONS
            {
                url: '/Commission',
                config: {
                    title: 'Commission',
                    templateUrl: '/app/RENDICONTAZIONE/COMMISSIONS/commissions.html?version=127'
                }
            }, {
                url: '/Commission/:CommissionId',
                config: {
                    title: 'CommissionDetail',
                    templateUrl: '/app/RENDICONTAZIONE/COMMISSIONS/commissions.html?version=127'
                }
            },
            //ASSISTANCES
            {
                url: '/Assistance',
                config: {
                    title: 'Assistance',
                    templateUrl: '/app/RENDICONTAZIONE/ASSISTANCES/assistances.html?version=127'
                }
            }, {
                url: '/Assistance/:ASTId',
                config: {
                    title: 'AssistanceDetail',
                    templateUrl: '/app/RENDICONTAZIONE/ASSISTANCES/assistances.html?version=127'
                }
            },
            //RIMBORSO
            {
                url: '/Rimborso',
                config: {
                    title: 'Rimborso',
                    templateUrl: '/app/RENDICONTAZIONE/RIMBORSO/rimborsi.html?version=127'
                }
            }, {
                url: '/Rimborso/:RimborsoId',
                config: {
                    title: 'RimborsoDetail',
                    templateUrl: '/app/RENDICONTAZIONE/RIMBORSO/rimborsi.html?version=127'
                }
            },
            //RIMBORSO-DEST
            {
                url: '/rimborsoDest',
                config: {
                    title: 'rimborsiDest',
                    templateUrl: '/app/RENDICONTAZIONE/RIMBORSODEST/rimborsoDest.html?version=127'
                }
            },
            //TIR RIMBORSO
            {
                url: '/tirRimborso',
                config: {
                    title: 'tirRimborso',
                    templateUrl: '/app/MISURA5/tirRimborso//tirRimborsi.html?version=127'
                }
            }, {
                url: '/tirRimborso/:TirRimborsoId',
                config: {
                    title: 'tirRimborsoDetail',
                    templateUrl: '/app/MISURA5/tirRimborso//tirRimborsi.html?version=127'
                }
            },
            //COLLOCAMENTO
            {
                url: '/coll',
                config: {
                    title: 'collocazioni',
                    templateUrl: '/app/MISURA3/coll/coll.html?version=127'
                }
            }, {
                url: '/coll/:CollId',
                config: {
                    title: 'collocazioni',
                    templateUrl: '/app/MISURA3/coll/coll.html?version=127'
                }
            },
            //COLLOCAMENTO RIMBORSO
            {
                url: '/collRimborso',
                config: {
                    title: 'collRimborsi',
                    templateUrl: '/app/MISURA3/collRimborso/collRimborsi.html?version=127'
                }
            },
            {
                url: '/collRimborso/:CollRimborsoId',
                config: {
                    title: 'collRimborso',
                    templateUrl: '/app/MISURA3/collRimborso/collRimborsi.html?version=127'
                }
            },
            //COLLOCAMENTO SERVIZIO
            {
                url: '/collServizio',
                config: {
                    title: 'collServizi',
                    templateUrl: '/app/MISURA3/collServizio/collServizi.html?version=127'
                }
            },
            {
                url: '/collServizio/:CollServizioId',
                config: {
                    title: 'collServizio',
                    templateUrl: '/app/MISURA3/collServizio/collServizi.html?version=127'
                }
            },
            //FAQ
            {
                url: '/faq',
                config: {
                    title: 'faq',
                    templateUrl: '/app/STRUMENTI/faq/faq.html?version=127'
                }
            },
            {
                url: '/faq/:faqId',
                config: {
                    title: 'faq',
                    templateUrl: '/app/STRUMENTI/faq/faq.html?version=127'
                }
            },
            {
                url: '/faqRead',
                config: {
                    title: 'faq',
                    templateUrl: '/app/STRUMENTI/faq/faqRead.html?version=127'
                }
            },
            //ATTACH
            {
                url: '/attach',
                config: {
                    title: 'attach',
                    templateUrl: '/app/ATT/attach/attach.html?version=127'
                }
            },
            {
                url: '/attach/:AttachId',
                config: {
                    title: 'attach',
                    templateUrl: '/app/ATT/attach/attach.html?version=127'
                }
            },
            //T_ATTACH
            {
                url: '/tAttach',
                config: {
                    title: 'tAttach',
                    templateUrl: '/app/ATT/tAttach/tAttach.html?version=127'
                }
            },
            {
                url: '/tAttach/:TAttachId',
                config: {
                    title: 'tAttach',
                    templateUrl: '/app/ATT/tAttach/tAttach.html?version=127'
                }
            },
            //TSOURCE
            {
                url: '/tSource',
                config: {
                    title: 'tSource',
                    templateUrl: '/app/ATT/att_tSource/att_tSource.html?version=127'
                }
            },
            {
                url: '/tSource/:TSourceId',
                config: {
                    title: 'tSource',
                    templateUrl: '/app/ATT/att_tSource/att_tSource.html?version=127'
                }
            },
            //RIMBORSO CLASSI
            {
                url: '/classeRimborso',
                config: {
                    title: 'classeRimborsi',
                    templateUrl: '/app/FORMAZIONE/classeRimborso/classeRimborsi.html?version=127'
                }
            },
            {
                url: '/classeRimborso/:RimborsoId',
                config: {
                    title: 'classeRimborso',
                    templateUrl: '/app/FORMAZIONE/classeRimborso/classeRimborsi.html?version=127'
                }
            },
            //RISORSA
            {
                url: '/risorsa',
                config: {
                    title: 'risorse',
                    templateUrl: '/app/WEB/risorsa/risorse.html?version=127'
                }
            }, {
                url: '/risorsa?ProfiloId=0&id=:RisorsaId',
                config: {
                    title: 'risorsaDetail',
                    templateUrl: '/app/WEB/risorsa/risorse.html?version=127'
                }
            },
            //CHECKLIST MODEL
            {
                url: '/checklistModel',
                config: {
                    title: 'checklistModel',
                    templateUrl: '/app/ckList/checklistModel/checklistModel.html?version=127'
                }
            }, {
                url: '/checklistModel/:ChecklistModelId',
                config: {
                    title: 'checklistModelDetail',
                    templateUrl: '/app/ckList/checklistModel/checklistModel.html?version=127'
                }
            },
            //CHECKLIST
            {
                url: '/checklist',
                config: {
                    title: 'checklist',
                    templateUrl: '/app/ckList/checklist/checklist.html?version=127'
                }
            }, {
                url: '/checklist/:ChecklistId',
                config: {
                    title: 'checklistDetail',
                    templateUrl: '/app/ckList/checklist/checklist.html?version=127'
                }
            },
            //USER
            {
                url: '/user',
                config: {
                    title: 'users',
                    templateUrl: '/app/web/web_user/users.html?version=127'
                }
            },
            {
                url: '/user/:UserId',
                config: {
                    title: 'userDetail',
                    templateUrl: '/app/web/web_user/users.html?version=127'
                }
            },
            //ROLES AUTHORIZATION
            {
                url: '/rolesAuthorization',
                config: {
                    title: 'rolesAuthorization',
                    templateUrl: '/app/WEB/rolesAuthorization/rolesAuthorization.html?version=127'
                }
            },
            {
                url: '/rolesAuthorization/:rolesAuthorizationId',
                config: {
                    title: 'rolesAuthorizationDetail',
                    templateUrl: '/app/WEB/rolesAuthorization/rolesAuthorization.html?version=127'
                }
            },
            //ROLES
            {
                url: '/roles',
                config: {
                    title: 'roles',
                    templateUrl: '/app/web/web_roles/roles.html?version=127'
                }
            },
            {
                url: '/roles/:rolesId',
                config: {
                    title: 'rolesDetail',
                    templateUrl: '/app/web/web_roles/roles.html?version=127'
                }
            },
            //AREAS
            {
                url: '/areas',
                config: {
                    title: 'areas',
                    templateUrl: '/app/web/web_areas/areas.html?version=127'
                }
            },
            {
                url: '/areas/:areaId',
                config: {
                    title: 'areaDetail',
                    templateUrl: '/app/web/web_areas/areas.html?version=127'
                }
            },
            //QUERY
            {
                url: '/query',
                config: {
                    title: 'gruppiDid',
                    templateUrl: '/app/STRUMENTI/query/query.html?version=127'
                }
            },
            //EDUP Question
            {
                url: '/EDUP_question',
                config: {
                    title: 'question',
                    templateUrl: '/app/EDUP/EDUP_question/questions.html?version=127'
                }
            }, {
                url: '/EDUP_question/:questionId/:testId',
                config: {
                    title: 'questionDetail',
                    templateUrl: '/app/EDUP/EDUP_question/questions.html?version=127'
                }
            },
            //EDUP Test
            {
                url: '/EDUP_test',
                config: {
                    title: 'test',
                    templateUrl: '/app/EDUP/EDUP_Test/tests.html?version=127'
                }
            }, {
                url: '/EDUP_test/:testId',
                config: {
                    title: 'testDetail',
                    templateUrl: '/app/EDUP/EDUP_Test/tests.html?version=127'
                }
            },
            //EDUP Session
            {
                url: '/EDUP_session',
                config: {
                    title: 'session',
                    templateUrl: '/app/EDUP/EDUP_Session/sessions.html?version=127'
                }
            }, {
                url: '/EDUP_session/:sessionId',
                config: {
                    title: 'sessionDetail',
                    templateUrl: '/app/EDUP/EDUP_Session/sessions.html?version=127'
                }
            },
            //ACCREDITAMENTO - BACK OFFICE
            {
                url: '/accreditamento',
                config: {
                    title: 'accreditamenti',
                    templateUrl: '/app/CND/CND_Accreditamento/BO/accreditamenti.html?version=127'
                }
            }, {
                url: '/accreditamento/:AccreditamentoId',
                config: {
                    title: 'accreditamentoDetail',
                    templateUrl: '/app/CND/CND_Accreditamento/BO/accreditamenti.html?version=127'
                }
            },
            //ADESIONE - BACK OFFICE
            {
                url: '/adesione',
                config: {
                    title: 'adesione',
                    templateUrl: '/app/CND/CND_Adesione/BO/adesioni.html?version=127'
                }
            }, {
                url: '/adesione/:AdesioneId',
                config: {
                    title: 'adesioneDetail',
                    templateUrl: '/app/CND/CND_Adesione/BO/adesioni.html?version=127'
                }
            },
            //CONVENZIONE - BACK OFFICE
            {
                url: '/convenzione',
                config: {
                    title: 'convenzioni',
                    templateUrl: '/app/CND/CND_Convenzione/BO/convenzioni.html?version=127'
                }
            }, {
                url: '/convenzione/:ConvenzioneId',
                config: {
                    title: 'convenzioneDetail',
                    templateUrl: '/app/CND/CND_Convenzione/BO/convenzioni.html?version=127'
                }
            },
            //Candidature - REGISTER - FRONT END
            {
                url: '/CNDRegister',
                config: {
                    title: 'register',
                    templateUrl: '/app/CND/CND_Register/cndRegisters.html?version=127'
                }
            }, {
                url: '/CNDRegister/:projectUID',
                config: {
                    title: 'registerDetail',
                    templateUrl: '/app/CND/CND_Register/cndRegisters.html?version=127'
                }
            },
            //Candidature - Accreditamenti - FRONT END
            {
                url: '/CNDAccreditamento',
                config: {
                    title: 'accreditamento',
                    templateUrl: '/app/CND/CND_Accreditamento/FE/cndAccreditamenti.html?version=127'
                }
            }, {
                url: '/CNDAccreditamento/:projectUID',
                config: {
                    title: 'accreditamentoDetail',
                    templateUrl: '/app/CND/CND_Accreditamento/FE/cndAccreditamenti.html?version=127'
                }
            }, {
                url: '/CNDAccreditamento/:projectUID/:accreditamentoUID',
                config: {
                    title: 'accreditamentoDetail',
                    templateUrl: '/app/CND/CND_Accreditamento/FE/cndAccreditamenti.html?version=127'
                }
            },
            //Candidature - Adesioni - FRONT END
            {
                url: '/CNDAdesione',
                config: {
                    title: 'adesione',
                    templateUrl: '/app/CND/CND_Adesione/FE/cndAdesioni.html?version=127'
                }
            }, {
                url: '/CNDAdesione/:projectUID',
                config: {
                    title: 'adesioneDetail',
                    templateUrl: '/app/CND/CND_Adesione/FE/cndAdesioni.html?version=127'
                }
            }, {
                url: '/CNDAdesione/:projectUID/:adesioneUID',
                config: {
                    title: 'accreditamentoDetail',
                    templateUrl: '/app/CND/CND_Adesione/FE/cndAdesioni.html?version=127'
                }
            },
            //Candidature - Convenzioni - FRONT END
            {
                url: '/CNDConvenzione',
                config: {
                    title: 'convenzione',
                    templateUrl: '/app/CND/CND_Convenzione/FE/cndConvenzioni.html?version=127'
                }
            }, {
                url: '/CNDConvenzione/:projectUID',
                config: {
                    title: ':convenzioneDetail',
                    templateUrl: '/app/CND/CND_Convenzione/FE/cndConvenzioni.html?version=127'
                }
            }, {
                url: '/CNDConvenzione/:projectUID/:convenzioneUID',
                config: {
                    title: ':convenzioneDetail',
                    templateUrl: '/app/CND/CND_Convenzione/FE/cndConvenzioni.html?version=127'
                }
            },
            //Candidature - Accreditamenti - Misura 1C - 3 - FRONT END
            {
                url: '/CNDAccred1C3',
                config: {
                    title: 'accred1C3',
                    templateUrl: '/app/CND/CNDAccred1C_3/FE/cndAccred1C_3.html?version=127'
                }
            }, {
                url: '/CNDAccred1C3/:projectUID',
                config: {
                    title: 'accredDetail1C3',
                    templateUrl: '/app/CND/CNDAccred1C_3/FE/cndAccred1C_3.html?version=127'
                }
            }, {
                url: '/CNDAccred1C3/:projectUID/:accreditamentoUID',
                config: {
                    title: 'accredDetail1C3',
                    templateUrl: '/app/CND/CNDAccred1C_3/FE/cndAccred1C_3.html?version=127'
                }
            },
            //ACCREDITAMENTO - Misura 1C - 3 - BACK OFFICE
            {
                url: '/accred1C3',
                config: {
                    title: 'accred1C3',
                    templateUrl: '/app/CND/CNDAccred1C_3/BO/accred1C_3.html?version=127'
                }
            }, {
                url: '/accred1C3/:AccredId1C3',
                config: {
                    title: 'accredDetail1C3',
                    templateUrl: '/app/CND/CNDAccred1C_3/BO/accred1C_3.html?version=127'
                }
            },
            //Candidature - Register - Misura 2A - FRONT END
            {
                url: '/CNDRegister2A',
                config: {
                    title: 'register2A',
                    templateUrl: '/app/CND/CNDRegister2A/FE/cndRegisters2A.html?version=127'
                }
            }, {
                url: '/CNDRegister2A/:projectUID',
                config: {
                    title: 'registerDetail2A',
                    templateUrl: '/app/CND/CNDRegister2A/FE/cndRegisters2A.html?version=127'
                }
            }, {
                url: '/CNDRegister2A/:projectUID/:registerUID',
                config: {
                    title: 'registerDetail2A',
                    templateUrl: '/app/CND/CNDRegister2A/FE/cndRegisters2A.html?version=127'
                }
            },
            //Candidature - Register - Misura 2B - FRONT END
            {
                url: '/CNDRegister2B',
                config: {
                    title: 'register2B',
                    templateUrl: '/app/CND/CNDRegister2B/FE/cndRegisters2B.html?version=127'
                }
            }, {
                url: '/CNDRegister2B/:projectUID',
                config: {
                    title: 'registerDetail2B',
                    templateUrl: '/app/CND/CNDRegister2B/FE/cndRegisters2B.html?version=127'
                }
            }, {
                url: '/CNDRegister2B/:projectUID/:registerUID',
                config: {
                    title: 'registerDetail2B',
                    templateUrl: '/app/CND/CNDRegister2B/FE/cndRegisters2B.html?version=127'
                }
            },
            //Candidature - Register - Misura 2C - FRONT END
            {
                url: '/CNDRegister2C',
                config: {
                    title: 'register2C',
                    templateUrl: '/app/CND/CNDRegister2C/FE/cndRegisters2C.html?version=127'
                }
            }, {
                url: '/CNDRegister2C/:projectUID',
                config: {
                    title: 'registerDetail2C',
                    templateUrl: '/app/CND/CNDRegister2C/FE/cndRegisters2C.html?version=127'
                }
            }, {
                url: '/CNDRegister2C/:projectUID/:registerUID',
                config: {
                    title: 'registerDetail2C',
                    templateUrl: '/app/CND/CNDRegister2C/FE/cndRegisters2C.html?version=127'
                }
            },
            //ACCREDITAMENTO - Misura 2C - BACK OFFICE
            {
                url: '/accred2C',
                config: {
                    title: 'accred2C',
                    templateUrl: '/app/CND/CNDAccred2C/BO/accred2C.html?version=127'
                }
            }, {
                url: '/accred2C/:AccredId2C',
                config: {
                    title: 'accredDetail2C',
                    templateUrl: '/app/CND/CNDAccred2C/BO/accred2C.html?version=127'
                }
            },
            //Candidature - Register - Misura 4A - FRONT END
            {
                url: '/CNDRegister4A',
                config: {
                    title: 'register4A',
                    templateUrl: '/app/CND/CNDRegister4A/FE/cndRegisters4A.html?version=127'
                }
            }, {
                url: '/CNDRegister4A/:projectUID',
                config: {
                    title: 'registerDetail4A',
                    templateUrl: '/app/CND/CNDRegister4A/FE/cndRegisters4A.html?version=127'
                }
            }, {
                url: '/CNDRegister4A/:projectUID/:registerUID',
                config: {
                    title: 'registerDetail4A',
                    templateUrl: '/app/CND/CNDRegister4A/FE/cndRegisters4A.html?version=127'
                }
            },
            //Candidature - Register - Misura 5 - FRONT END
            {
                url: '/CNDRegister5',
                config: {
                    title: 'register5',
                    templateUrl: '/app/CND/CNDRegister5/FE/cndRegisters5.html?version=127'
                }
            }, {
                url: '/CNDRegister5/:projectUID',
                config: {
                    title: 'registerDetail5',
                    templateUrl: '/app/CND/CNDRegister5/FE/cndRegisters5.html?version=127'
                }
            }, {
                url: '/CNDRegister5/:projectUID/:registerUID',
                config: {
                    title: 'registerDetail5',
                    templateUrl: '/app/CND/CNDRegister5/FE/cndRegisters5.html?version=127'
                }
            },
            //Candidature - Register - Misura 5Bis - FRONT END
            {
                url: '/CNDRegister5Bis',
                config: {
                    title: 'register5Bis',
                    templateUrl: '/app/CND/CNDRegister5Bis/FE/cndRegisters5Bis.html?version=127'
                }
            }, {
                url: '/CNDRegister5Bis/:projectUID',
                config: {
                    title: 'registerDetail5Bis',
                    templateUrl: '/app/CND/CNDRegister5Bis/FE/cndRegisters5Bis.html?version=127'
                }
            }, {
                url: '/CNDRegister5Bis/:projectUID/:registerUID',
                config: {
                    title: 'registerDetail5Bis',
                    templateUrl: '/app/CND/CNDRegister5Bis/FE/cndRegisters5Bis.html?version=127'
                }
            },
            //Candidature - Register - GOL - FRONT END
            {
                url: '/CNDRegisterGOL',
                config: {
                    title: 'registerGOL',
                    templateUrl: '/app/CND/CNDRegisterGOL/FE/cndRegistersGOL.html?version=127'
                }
            }, {
                url: '/CNDRegisterGOL/:projectUID',
                config: {
                    title: 'registerDetailGOL',
                    templateUrl: '/app/CND/CNDRegisterGOL/FE/cndRegistersGOL.html?version=127'
                }
            }, {
                url: '/CNDRegisterGOL/:projectUID/:registerUID',
                config: {
                    title: 'registerDetailGOL',
                    templateUrl: '/app/CND/CNDRegisterGOL/FE/cndRegistersGOL.html?version=127'
                }
            },
            //Candidature - Accreditamenti - Misura 7 - FRONT END
            {
                url: '/CNDAccred7',
                config: {
                    title: 'accred7',
                    templateUrl: '/app/CND/CNDAccred7/FE/cndAccred7.html?version=127'
                }
            }, {
                url: '/CNDAccred7/:projectUID',
                config: {
                    title: 'accredDetail7',
                    templateUrl: '/app/CND/CNDAccred7/FE/cndAccred7.html?version=127'
                }
            }, {
                url: '/CNDAccred7/:projectUID/:accreditamentoUID',
                config: {
                    title: 'accredDetail7',
                    templateUrl: '/app/CND/CNDAccred7/FE/cndAccred7.html?version=127'
                }
            },
            //ACCREDITAMENTO - Misura 7 - BACK OFFICE
            {
                url: '/accred7',
                config: {
                    title: 'accred7',
                    templateUrl: '/app/CND/CNDAccred7/BO/accred7.html?version=127'
                }
            }, {
                url: '/accred7/:AccredId7',
                config: {
                    title: 'accredDetail7',
                    templateUrl: '/app/CND/CNDAccred7/BO/accred7.html?version=127'
                }
            },
            //PARTECIPAZIONE
            {
                url: '/cndPartecipazione',
                config: {
                    title: 'cndPartecipazione',
                    templateUrl: '/app/CND/CNDPartecipazione/cndPartecipazioni.html?version=127'
                }
            },
            {
                url: '/cndPartecipazione/:CNDPartecipazioneId',
                config: {
                    title: 'cndPartecipazione',
                    templateUrl: '/app/CND/CNDPartecipazione/cndPartecipazioni.html?version=127'
                }
            },
            //CNDPROGETTO
            {
                url: '/cndProgetto',
                config: {
                    title: 'cndProgetto',
                    templateUrl: '/app/CND/CNDProgetto/cndProgetti.html?version=127'
                }
            },
            {
                url: '/cndProgetto/:CNDProgettoId',
                config: {
                    title: 'cndProgetto',
                    templateUrl: '/app/CND/CNDProgetto/cndProgetti.html?version=127'
                }
            },
            //CATALOGO CORSO - MISURA 2A
            {
                url: '/cndPCorso2A',
                config: {
                    title: 'cndPCorso2A',
                    templateUrl: '/app/CND/CNDPCorsi2A/cndPCorsi2A.html?version=127'
                }
            },
            {
                url: '/cndPCorso2A/:CNDPCorso2AId',
                config: {
                    title: 'cndPCorso2A',
                    templateUrl: '/app/CND/CNDPCorsi2A/cndPCorsi2A.html?version=127'
                }
            },
            //CATALOGO CORSO - MISURA 2B
            {
                url: '/cndPCorso2B',
                config: {
                    title: 'cndPCorso2B',
                    templateUrl: '/app/CND/CNDPCorsi2B/cndPCorsi2B.html?version=127'
                }
            },
            {
                url: '/cndPCorso2B/:CNDPCorso2BId',
                config: {
                    title: 'cndPCorso2B',
                    templateUrl: '/app/CND/CNDPCorsi2B/cndPCorsi2B.html?version=127'
                }
            },
            //CATALOGO CORSO - MISURA 4A
            {
                url: '/cndPCorso4A',
                config: {
                    title: 'cndPCorso4A',
                    templateUrl: '/app/CND/CNDPCorsi4A/cndPCorsi4A.html?version=127'
                }
            },
            {
                url: '/cndPCorso4A/:CNDPCorso4AId',
                config: {
                    title: 'cndPCorso4A',
                    templateUrl: '/app/CND/CNDPCorsi4A/cndPCorsi4A.html?version=127'
                }
            },
            //PROTOCOLLO
            {
                url: '/protocollo',
                config: {
                    title: 'protocollo',
                    templateUrl: '/app/SILAV/PROTOCOLLO/protocolli.html?version=127'
                }
            }, {
                url: '/protocollo/:ProtocolloId',
                config: {
                    title: 'protocolloDetail',
                    templateUrl: '/app/SILAV/PROTOCOLLO/protocolli.html?version=127'
                }
            },
            //SILAV-APL
            {
                url: '/silavAPL',
                config: {
                    title: 'silavAPL',
                    templateUrl: '/app/SILAV/SilavAPL/SilavAPL.html?version=127'
                }
            }, {
                url: '/silavAPL/:SilavAPLId',
                config: {
                    title: 'protocolloDetail',
                    templateUrl: '/app/SILAV/SilavAPL/SilavAPL.html?version=127'
                }
            },
            //SILAV-CPI
            {
                url: '/silavCPI',
                config: {
                    title: 'silavCPI',
                    templateUrl: '/app/SILAV/SilavCPI/SilavCPI.html?version=127'
                }
            }, {
                url: '/silavCPI/:SilavCPIId',
                config: {
                    title: 'protocolloDetail',
                    templateUrl: '/app/SILAV/SilavCPI/SilavCPI.html?version=127'
                }
            }
        ];
    }
})();